var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuccessStatus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66746",
    "data-name": "Group 66746",
    transform: "translate(-664.5 -214.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4119",
    "data-name": "Ellipse 4119",
    transform: "translate(665.5 215.813)",
    fill: "#e9f7eb",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.849,
    cy: 18.849,
    r: 18.849,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.849,
    cy: 18.849,
    r: 18.349,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Check_Mark",
    d: "M20,40A20,20,0,1,1,40,20,20.023,20.023,0,0,1,20,40ZM20,2.5A17.5,17.5,0,1,0,37.5,20,17.52,17.52,0,0,0,20,2.5ZM17.134,27.134l12.5-12.5a1.25,1.25,0,1,0-1.767-1.767L16.25,24.483l-4.116-4.116a1.25,1.25,0,1,0-1.767,1.767l5,5a1.249,1.249,0,0,0,1.767,0Z",
    transform: "translate(664.5 214.884)",
    fill: "#1eac8f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessStatus);
export default __webpack_public_path__ + "static/media/IconSuccessStatus.4d3f9487b646e13c8c88b12f821caeec.svg";
export { ForwardRef as ReactComponent };